module.exports = __webpack_public_path__ + "rakutenstay-logo.png?a41c998f5e28b4e3fcb415d8b34cf7d5";